module.exports = __webpack_public_path__ + "files/5f8792a12ff6c6cf41525e8c140bf011.png";